<template>
    <div>
        <vue-headful
            title="Sisterhood Game"
            description="Sisterhood is a biography game that lets you experience the lives of historic, adventurous women from all corners of the world."
            :image="introIllustration"
        />
        <Header/>
        <IntroImage/>
        <Logo/>
        <IntroText/>
        <AboutText/>
        <News/>
        <Team/>
    </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import IntroImage from "@/components/IntroImage.vue";
import Logo from "@/components/Logo.vue";
import IntroText from "@/components/IntroText.vue";
import AboutText from "@/components/AboutText.vue";
import News from "@/components/News.vue";
import Team from "@/components/Team.vue";

import Illustration from "@/assets/img/intro-illustration.png";

export default {
    name: "home",
    components: {
        Header,
        IntroImage,
        Logo,
        IntroText,
        AboutText,
        News,
        Team
    },
    data() {
        return {
            introIllustration: Illustration
        };
    }
};
</script>
